import * as React from "react";
import {PremiumType, UPFRONT_PAYMENT_THRESHOLD} from "@falcon/services";
import {MtaSuccessModalWording} from "./MtaSuccessModalWording";
import {IFactors} from "./GeneratorInputTypes";
import {EditCarMtaSuccessModalWordingGenerator} from "./EditCarMtaSuccessModalWordingGenerator";
import * as successModals from "../../../../../../components/modals/SuccessModalRenderers";

export interface IVehicle {
    registrationNumber: string | null;
    make: string | null;
    model: string | null;
}

export interface IUiState {
    payFullPrice: boolean,
    removedDriverFullName: string;
}

export interface IVehicle {
    registrationNumber: string | null;
    make: string | null;
    model: string | null;
}

export interface IDriver {
    firstName: string,
    lastName: string;
}

export class AddDriverMtaSuccessModalWordingGenerator {

    public static readonly generateModalWording = (factors: IFactors, uistate: IUiState, vehicle: IVehicle, additionalDrivers: IDriver[],
                                                   cardNumber: string, conditions: any, previousMonthlyPremium: any): MtaSuccessModalWording => {
        const {agreeToReuseCardDetails, instalmentsNotPaidOff} = conditions;

        const premiumType: PremiumType = PremiumType[factors.premiumType as keyof typeof PremiumType];

        let modalTitle: React.ReactNode;
        let modalBody: React.ReactNode;

        if (factors.additionalPremium > 0 && (premiumType === PremiumType.annual || uistate.payFullPrice)) {
            modalTitle = "Payment was successful";
            const modalContent = (
                <>
                    for
                    adding {AddDriverMtaSuccessModalWordingGenerator.generateAddDriverToVehicleText(vehicle, additionalDrivers)}
                </>
            )
            modalBody = successModals.paymentSuccessfulAdditionalPremiumModal(factors.additionalPremium, cardNumber, modalContent, agreeToReuseCardDetails);
        } else if (factors.additionalPremium > 0 && premiumType === PremiumType.monthly && factors.upfrontPaymentAmount >= UPFRONT_PAYMENT_THRESHOLD && !uistate.payFullPrice) {
            modalTitle = "Payment was successful";
            const modalContent = (
                <>
                    for
                    adding {AddDriverMtaSuccessModalWordingGenerator.generateAddDriverToVehicleText(vehicle, additionalDrivers)}{" "}
                </>
            )
            modalBody = successModals.paymentSuccessfulAdditionalPremiumMonthlyModal(factors.upfrontPaymentAmount, factors.monthlyPaymentSpreadAmount, cardNumber, modalContent, agreeToReuseCardDetails);
        } else if (factors.additionalPremium > 0 && premiumType === PremiumType.monthly && factors.upfrontPaymentAmount < UPFRONT_PAYMENT_THRESHOLD && !uistate.payFullPrice) {
            // TODO: neither the driver nor the car is mentioned. Intentional?
            modalTitle = "Your payment plan has been updated";
                const monthlyPaymentAmount: number = factors.monthlyPaymentSpreadWithInterestAmount || factors.monthlyPaymentSpreadAmount;
                modalBody = successModals.paymentPlanUpdatedAdditionalPremiumModal(monthlyPaymentAmount, factors.monthlyPremium, previousMonthlyPremium);
        } else if (factors.returnPremium > 0 && premiumType === PremiumType.monthly && factors.monthlyPremium !== 0) {
            // TODO: neither the driver nor the car is mentioned. Intentional?
            modalTitle = this.instalmentsNotPaidOffModalTitle(instalmentsNotPaidOff);
            modalBody = successModals.paymentPlanUpdatedRefundModal(factors.returnPremium, factors.monthlyPremium, previousMonthlyPremium, instalmentsNotPaidOff);
        } else if (factors.returnPremium > 0 && premiumType === PremiumType.annual) {
            modalTitle = "Your refund is on the way";
            const modalContent = (
                <>
                    for
                    adding {AddDriverMtaSuccessModalWordingGenerator.generateAddDriverToVehicleText(vehicle, additionalDrivers)}
                </>
            )
            modalBody = successModals.paymentSuccessfulRefundModal(factors.returnPremium, modalContent);
        } else {
            modalTitle = "All done";
            modalBody = (
                <p className="font-weight-extra-light">
                    We’ve saved your changes, and there’s no extra cost for adding{" "}
                    {AddDriverMtaSuccessModalWordingGenerator.generateAddDriverToVehicleText(vehicle, additionalDrivers)}
                </p>
            )
        }

        return new MtaSuccessModalWording(modalTitle, modalBody, EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalTitle(), EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalBody());
    }

    private static instalmentsNotPaidOffModalTitle(instalmentsNotPaidOff: any) {
        if (instalmentsNotPaidOff) {
            return "Your payment plan has been updated";
        } else {
            return "Your refund is on the way";
        }
    }

    public static generateAddDriverToVehicleText(vehicle: IVehicle, additionalDrivers: IDriver[]): string {
        return `${AddDriverMtaSuccessModalWordingGenerator.generateAddDriverText(additionalDrivers)} of ${vehicle.make}, ${vehicle.model} (${vehicle.registrationNumber}).`
    }

    public static generateAddDriverText(additionalDrivers: IDriver[]): string {
        const additionalDriversNames = additionalDrivers.map((driver: any) =>
            driver.firstName + " " + driver.lastName
        );
        return `${additionalDriversNames.join(', ')} as ${additionalDrivers.length === 1 ? 'an additional driver' : 'additional drivers'}`
    }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/annual/motor/yourCarsPage/modal/AddDriverMtaSuccessModalWordingGenerator.tsx